import './ProductsRoot.scss';
import Component from './ProductsRoot.js';
export default Component;
